import { WidgetType } from '@enums/WidgetType'
import { UtmLeadProductType } from '@enums/UtmLeadProduct'
import {
  ABHA_SEO_WIDGET,
  CHALLAN_WIDGET_LANDING,
  FASTAG_WIDGET_LANDING,
  HSRP_WIDGET_LANDING,
  RTO_WIDGET,
} from '@components/Product/ProductWidget/constants'
import {
  CHALLAN_WIDGET_SCANNER,
  PUC_ACKO_DRIVE_SCANNER,
  PUC_SEO_SCANNER,
  RTO_DETAIL_ACKO_DRIVE_SCANNER,
  RTO_DETAIL_SCANNER,
  RTO_VEHICLE_INFO_SCANNER,
} from './widgetImagesConstant'
import { CHALLAN_WIDGET_DESCRIPTION, PUC_WIDGET_DESCRIPTION, RTO_DETAIL_DESCRIPTION } from './commonConstants'

export const commonWidgetConfig = {
  default_deep_link: {
    [WidgetType.PUC_WIDGET]: 'https://ackoapp.onelink.me/TnnH/kolf7khp',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'https://ackoapp.onelink.me/TnnH/kolf7khp',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'https://ackoapp.onelink.me/TnnH/wbt2ms5q',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'https://ackoapp.onelink.me/TnnH/wbt2ms5q',
    [WidgetType.RTO_DETAIL_WIDGET]: 'https://ackoapp.onelink.me/TnnH/kolf7khp',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'https://ackoapp.onelink.me/TnnH/kolf7khp',
    [WidgetType.CHALLAN_WIDGET]: 'https://ackoctv.onelink.me/pNs0/xk00tycj',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'https://ackoctv.onelink.me/pNs0/xk00tycj',
    [WidgetType.RTO_WIDGET]: 'https://ackoapp.onelink.me/TnnH/wbt2ms5q',
  },

  app_link: regNo => ({
    [WidgetType.PUC_WIDGET]: `acko.com://puc?reg_num=${regNo}`,
    [WidgetType.PUC_WIDGET_ACKODRIVE]: `acko.com://puc?reg_num=${regNo}`,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: `acko.com://rto_details?reg_num=${regNo}`,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: `acko.com://rto_details?reg_num=${regNo}`,
    [WidgetType.RTO_DETAIL_WIDGET]: `acko.com://rto_details?reg_num=${regNo}`,
    [WidgetType.RTO_DETAIL_ACKODRIVE]: `acko.com://rto_details?reg_num=${regNo}`,
    [WidgetType.CHALLAN_WIDGET]: `acko.com://pending_challan?reg_num=${regNo}`,
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: `acko.com://pending_challan?reg_num=${regNo}`,
    [WidgetType.RTO_WIDGET]: `acko.com://rto_details?reg_num=${regNo}`,
  }),

  deep_link_value: {
    [WidgetType.PUC_WIDGET]: 'acko.com://puc_validity_lookup',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'acko.com://puc_validity_lookup',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'acko.com://rto_information',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'acko.com://rto_information',
    [WidgetType.RTO_DETAIL_WIDGET]: 'acko.com://rto_information',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'acko.com://rto_information',
    [WidgetType.CHALLAN_WIDGET]: 'acko.com://check_challan',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'acko.com://check_challan',
    [WidgetType.CHALLAN_WIDGET_LANDING]: 'acko.com://pending_challan',
    [WidgetType.RTO_WIDGET]: 'acko.com://rto_details',
  },

  product: {
    [WidgetType.PUC_WIDGET]: 'SEO_PUC',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'SEO_PUC',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'SEO_vehicle_information',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'SEO_vehicle_information',
    [WidgetType.RTO_DETAIL_WIDGET]: 'SEO_RTO',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'SEO_RTO',
    [WidgetType.CHALLAN_WIDGET]: 'SEO_CHALLAN',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'SEO_CHALLAN',
    [WidgetType.RTO_WIDGET]: 'SEO_vehicle_information',
  },

  configName: {
    [WidgetType.PUC_WIDGET]: 'PUC_widget',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'PUC_widget',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'RTO_widget',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'RTO_widget',
    [WidgetType.RTO_DETAIL_WIDGET]: 'RTO_Detail_widget',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'RTO_Detail_widget',
    [WidgetType.CHALLAN_WIDGET]: 'challan_widget',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'challan_widget',
    [WidgetType.RTO_WIDGET]: 'RTO_widget',
  },
  scannerImg: {
    [WidgetType.PUC_WIDGET]: PUC_SEO_SCANNER,
    [WidgetType.PUC_WIDGET_ACKODRIVE]: PUC_ACKO_DRIVE_SCANNER,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: RTO_VEHICLE_INFO_SCANNER,
    [WidgetType.RTO_DETAIL_WIDGET]: RTO_DETAIL_SCANNER,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: RTO_VEHICLE_INFO_SCANNER,
    [WidgetType.RTO_DETAIL_ACKODRIVE]: RTO_DETAIL_ACKO_DRIVE_SCANNER,
    [WidgetType.CHALLAN_WIDGET]: CHALLAN_WIDGET_SCANNER,
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: CHALLAN_WIDGET_SCANNER,
    [WidgetType.RTO_WIDGET]: RTO_VEHICLE_INFO_SCANNER,
  },
  widgetDescription: {
    [WidgetType.PUC_WIDGET]: PUC_WIDGET_DESCRIPTION,
    [WidgetType.PUC_WIDGET_ACKODRIVE]: PUC_WIDGET_DESCRIPTION,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: RTO_DETAIL_DESCRIPTION,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: RTO_DETAIL_DESCRIPTION,
    [WidgetType.RTO_DETAIL_WIDGET]: RTO_DETAIL_DESCRIPTION,
    [WidgetType.RTO_DETAIL_ACKODRIVE]: RTO_DETAIL_DESCRIPTION,
    [WidgetType.CHALLAN_WIDGET]: CHALLAN_WIDGET_DESCRIPTION,
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: CHALLAN_WIDGET_DESCRIPTION,
    [WidgetType.RTO_WIDGET]: RTO_DETAIL_DESCRIPTION,
  },
  source: {
    [WidgetType.PUC_WIDGET]: 'SEO_PUC',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'SEO_PUC',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'SEO_VEHICLE_INFORMATION',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'SEO_VEHICLE_INFORMATION',
    [WidgetType.RTO_DETAIL_WIDGET]: 'SEO_VEHICLE_INFORMATION',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'SEO_VEHICLE_INFORMATION',
    [WidgetType.CHALLAN_WIDGET]: 'SEO_CHALLAN_PAGE',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'SEO_CHALLAN_PAGE',
    [WidgetType.CHALLAN_WIDGET_LANDING]: 'SEO_CHALLAN_PAGE',
    [WidgetType.RTO_WIDGET]: 'SEO_VEHICLE_INFORMATION',
  },
  apiKey: {
    [WidgetType.PUC_WIDGET]: 'p1imWcCFBTEZ3Q',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'p1imWcCFBTEZ3Q',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'r7imWcSWATEZ2R',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'r7imWcSWATEZ2R',
    [WidgetType.RTO_DETAIL_WIDGET]: 'r7imWcSWATEZ2R',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'r7imWcSWATEZ2R',
    [WidgetType.CHALLAN_WIDGET]: 's7imWcVPATEZ5A',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 's7imWcVPATEZ5A',
    [WidgetType.CHALLAN_WIDGET_LANDING]: 's7imWcVPATEZ5A',
    [WidgetType.RTO_WIDGET]: 's7imWcVPATAD1A',
  },
  loginText: {
    [WidgetType.PUC_WIDGET]: 'GET PUC details',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'GET PUC details',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'GET vehicle details',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'GET vehicle details',
    [WidgetType.RTO_DETAIL_WIDGET]: 'Get RTO details',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'Get RTO details',
    [WidgetType.CHALLAN_WIDGET]: 'GET vehicle details',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'GET vehicle details',
    [WidgetType.RTO_WIDGET]: 'GET vehicle details',
    default: 'Get details',
  },
}

export const vehicleTypeConfig = {
  PRIVATE_CAR: 'Car',
  TWO_WHEELER: 'Bike',
  DEFAULT: 'N/A',
}

export const CAMPAIGN_NAME = {
  PMAX_CHALLAN: 'pmax-challan-may25',
  SEO_CHALLAN: 'seo-challan-jan25',
  SEM_CHALLAN: 'sem-challan-jan25',
  SEM_CHALLAN_1: 'sem-challan-1',
  SEM_CHALLAN_2: 'sem-challan-2',
  SEM_CHALLAN_3: 'sem-challan-3',
  SEM_CHALLAN_4: 'sem-challan-4',
  SEM_CHALLAN_5: 'sem-challan-5',
  SEM_CHALLAN_6: 'sem-challan-6',
  SEM_CHALLAN_7: 'sem-challan-7',
  SEM_CHALLAN_8: 'sem-challan-8',
  SEM_CHALLAN_9: 'sem-challan-9',
  SEM_CHALLAN_10: 'sem-challan-10',
  META_CHALLAN: 'meta-challan-jan25',
  INSTAGRAM_CHALLAN: 'instagram-challan-jun25',
  ZEPTO_CHALLAN: 'zepto-challan-jun25',
  ZOMATO_CHALLAN: 'zomato-challan-jun25',
  SEO_FASTag: 'SEO_Fastag',
  SEM_FASTAG: 'sem-fastag-july25',
  PMAX_FASTAG: 'pmax-fastag-july25',
  BRANDFORMANCE_FASTAG: 'brandformance-fastag-july25',
  META_FASTAG: 'meta-fastag-july25',
  WHATSAPP_WINBACK_CHALLAN: 'winback-challan-may25',
  BRANDFORMANCE_CHALLAN: 'brandformance-challan-may25',
  SEO_HSRP: 'seo-hsrp-may25',
  SEM_HSRP: 'sem-hsrp-may25',
  CX_WA_WNBCK_CHLN_U1: 'cx_wa_wnbck_chln_u1',
  CX_WA_WNBCK_CHLN_U2: 'cx_wa_wnbck_chln_u2',
  CX_WA_WNBCK_CHLN_U3: 'cx_wa_wnbck_chln_u3',
  CX_WA_WNBCK_CHLN_U4: 'cx_wa_wnbck_chln_u4',
  CX_WA_WNBCK_CHLN_P1: 'cx_wa_wnbck_chln_p1',
  NCX_WA_WNBCK_CHLN_U1: 'ncx_wa_wnbck_chln_u1',
  NCX_WA_WNBCK_CHLN_U2: 'ncx_wa_wnbck_chln_u2',
  NCX_WA_WNBCK_CHLN_U3: 'ncx_wa_wnbck_chln_u3',
  NCX_WA_WNBCK_CHLN_U4: 'ncx_wa_wnbck_chln_u4',
  NCX_WA_WNBCK_CHLN_P1: 'ncx_wa_wnbck_chln_p1',
  META_CHALLAN_INF1: 'meta-challan-jan25',
  META_CHALLAN_INF2: 'meta-challan-jan25',
  META_CHALLAN_INF3: 'meta-challan-jan25',
  META_CHALLAN_INF4: 'meta-challan-jan25',
  META_CHALLAN_INF5: 'meta-challan-jan25',
  YT_CHALLAN_INF1: 'meta-challan-jan25',
  YT_CHALLAN_INF2: 'meta-challan-jan25',
  YT_CHALLAN_INF3: 'meta-challan-jan25',
  YT_CHALLAN_INF4: 'meta-challan-jan25',
  YT_CHALLAN_INF5: 'meta-challan-jan25',
  KA_DISC_CHLN_GOV: 'ka_disc_chln_gov',
  SEO_RTO: 'SEO_vehicle_information',
  SEO_ABHA: 'wrapper_app_download_abha',
}

export const CAMPAIGN_SOURCE = {
  PMAX_CHALLAN: 'PMAX_CHALLAN',
  SEO_CHALLAN: 'SEO_CHALLAN',
  SEM_CHALLAN: 'SEM_CHALLAN',
  SEM_CHALLAN_1: 'SEM_CHALLAN_1',
  SEM_CHALLAN_2: 'SEM_CHALLAN_2',
  SEM_CHALLAN_3: 'SEM_CHALLAN_3',
  SEM_CHALLAN_4: 'SEM_CHALLAN_4',
  SEM_CHALLAN_5: 'SEM_CHALLAN_5',
  SEM_CHALLAN_6: 'SEM_CHALLAN_6',
  SEM_CHALLAN_7: 'SEM_CHALLAN_7',
  SEM_CHALLAN_8: 'SEM_CHALLAN_8',
  SEM_CHALLAN_9: 'SEM_CHALLAN_9',
  SEM_CHALLAN_10: 'SEM_CHALLAN_10',
  META_CHALLAN: 'META_CHALLAN',
  INSTAGRAM_CHALLAN: 'INSTAGRAM_CHALLAN',
  ZEPTO_CHALLAN: 'ZEPTO_CHALLAN',
  ZOMATO_CHALLAN: 'ZOMATO_CHALLAN',
  SEO_FASTag: 'SEO',
  SEM_FASTAG: 'SEM',
  PMAX_FASTAG: 'PMAX',
  BRANDFORMANCE_FASTAG: 'DV360',
  META_FASTAG: 'META',
  WHATSAPP_CHALLAN: 'WHATSAPP',
  WHATSAPP_WINBACK_CHALLAN: 'WHATSAPP_WINBACK_CHALLAN',
  BRANDFORMANCE_CHALLAN: 'BRANDFORMANCE_CHALLAN',
  SEO_HSRP: 'SEO',
  SEM_HSRP: 'SEM',
  CX_WA_WNBCK_CHLN_U1: 'CX_WA_WNBCK_CHLN_U1',
  CX_WA_WNBCK_CHLN_U2: 'CX_WA_WNBCK_CHLN_U2',
  CX_WA_WNBCK_CHLN_U3: 'CX_WA_WNBCK_CHLN_U3',
  CX_WA_WNBCK_CHLN_U4: 'CX_WA_WNBCK_CHLN_U4',
  CX_WA_WNBCK_CHLN_P1: 'CX_WA_WNBCK_CHLN_P1',
  NCX_WA_WNBCK_CHLN_U1: 'NCX_WA_WNBCK_CHLN_U1',
  NCX_WA_WNBCK_CHLN_U2: 'NCX_WA_WNBCK_CHLN_U2',
  NCX_WA_WNBCK_CHLN_U3: 'NCX_WA_WNBCK_CHLN_U3',
  NCX_WA_WNBCK_CHLN_U4: 'NCX_WA_WNBCK_CHLN_U4',
  NCX_WA_WNBCK_CHLN_P1: 'NCX_WA_WNBCK_CHLN_P1',
  META_CHALLAN_INF1: 'META_CHALLAN_INF1',
  META_CHALLAN_INF2: 'META_CHALLAN_INF2',
  META_CHALLAN_INF3: 'META_CHALLAN_INF3',
  META_CHALLAN_INF4: 'META_CHALLAN_INF4',
  META_CHALLAN_INF5: 'META_CHALLAN_INF5',
  YT_CHALLAN_INF1: 'YT_CHALLAN_INF1',
  YT_CHALLAN_INF2: 'YT_CHALLAN_INF2',
  YT_CHALLAN_INF3: 'YT_CHALLAN_INF3',
  YT_CHALLAN_INF4: 'YT_CHALLAN_INF4',
  YT_CHALLAN_INF5: 'YT_CHALLAN_INF5',
  KA_DISC_CHLN_GOV: 'KA_DISC_CHLN_GOV',
  SEO_RTO: 'SEO',
  SEO_ABHA: 'wrapper_app_download_abha',
}

export const campaignNameConfig = {
  [UtmLeadProductType.PMAX_CHALLAN]: CAMPAIGN_NAME.PMAX_CHALLAN,
  [UtmLeadProductType.SEM_CHALLAN]: CAMPAIGN_NAME.SEM_CHALLAN,
  [UtmLeadProductType.SEM_CHALLAN_1]: CAMPAIGN_NAME.SEM_CHALLAN_1,
  [UtmLeadProductType.SEM_CHALLAN_2]: CAMPAIGN_NAME.SEM_CHALLAN_2,
  [UtmLeadProductType.SEM_CHALLAN_3]: CAMPAIGN_NAME.SEM_CHALLAN_3,
  [UtmLeadProductType.SEM_CHALLAN_4]: CAMPAIGN_NAME.SEM_CHALLAN_4,
  [UtmLeadProductType.SEM_CHALLAN_5]: CAMPAIGN_NAME.SEM_CHALLAN_5,
  [UtmLeadProductType.SEM_CHALLAN_6]: CAMPAIGN_NAME.SEM_CHALLAN_6,
  [UtmLeadProductType.SEM_CHALLAN_7]: CAMPAIGN_NAME.SEM_CHALLAN_7,
  [UtmLeadProductType.SEM_CHALLAN_8]: CAMPAIGN_NAME.SEM_CHALLAN_8,
  [UtmLeadProductType.SEM_CHALLAN_9]: CAMPAIGN_NAME.SEM_CHALLAN_9,
  [UtmLeadProductType.SEM_CHALLAN_10]: CAMPAIGN_NAME.SEM_CHALLAN_10,
  [UtmLeadProductType.META_CHALLAN]: CAMPAIGN_NAME.META_CHALLAN,
  [UtmLeadProductType.SEO_CHALLAN]: CAMPAIGN_NAME.SEO_CHALLAN,
  [UtmLeadProductType.INSTAGRAM_CHALLAN]: CAMPAIGN_NAME.INSTAGRAM_CHALLAN,
  [UtmLeadProductType.ZEPTO_CHALLAN]: CAMPAIGN_NAME.ZEPTO_CHALLAN,
  [UtmLeadProductType.ZOMATO_CHALLAN]: CAMPAIGN_NAME.ZOMATO_CHALLAN,
  [UtmLeadProductType.SEO_FASTAG]: CAMPAIGN_NAME.SEO_FASTag,
  [UtmLeadProductType.SEM_FASTAG]: CAMPAIGN_NAME.SEM_FASTAG,
  [UtmLeadProductType.PMAX_FASTAG]: CAMPAIGN_NAME.PMAX_FASTAG,
  [UtmLeadProductType.BRANDFORMANCE_FASTAG]: CAMPAIGN_NAME.BRANDFORMANCE_FASTAG,
  [UtmLeadProductType.META_FASTAG]: CAMPAIGN_NAME.META_FASTAG,
  [UtmLeadProductType.WHATSAPP_WINBACK_CHALLAN]: CAMPAIGN_NAME.WHATSAPP_WINBACK_CHALLAN,
  [UtmLeadProductType.BRANDFORMANCE_CHALLAN]: CAMPAIGN_NAME.BRANDFORMANCE_CHALLAN,
  [UtmLeadProductType.SEO_HSRP]: CAMPAIGN_NAME.SEM_HSRP,
  [UtmLeadProductType.SEM_HSRP]: CAMPAIGN_NAME.SEM_HSRP,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_U1]: CAMPAIGN_NAME.CX_WA_WNBCK_CHLN_U1,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_U2]: CAMPAIGN_NAME.CX_WA_WNBCK_CHLN_U2,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_U3]: CAMPAIGN_NAME.CX_WA_WNBCK_CHLN_U3,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_U4]: CAMPAIGN_NAME.CX_WA_WNBCK_CHLN_U4,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_P1]: CAMPAIGN_NAME.CX_WA_WNBCK_CHLN_P1,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U1]: CAMPAIGN_NAME.NCX_WA_WNBCK_CHLN_U1,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U2]: CAMPAIGN_NAME.NCX_WA_WNBCK_CHLN_U2,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U3]: CAMPAIGN_NAME.NCX_WA_WNBCK_CHLN_U3,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U4]: CAMPAIGN_NAME.NCX_WA_WNBCK_CHLN_U4,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_P1]: CAMPAIGN_NAME.NCX_WA_WNBCK_CHLN_P1,
  [UtmLeadProductType.META_CHALLAN_INF1]: CAMPAIGN_NAME.META_CHALLAN_INF1,
  [UtmLeadProductType.META_CHALLAN_INF2]: CAMPAIGN_NAME.META_CHALLAN_INF2,
  [UtmLeadProductType.META_CHALLAN_INF3]: CAMPAIGN_NAME.META_CHALLAN_INF3,
  [UtmLeadProductType.META_CHALLAN_INF4]: CAMPAIGN_NAME.META_CHALLAN_INF4,
  [UtmLeadProductType.META_CHALLAN_INF5]: CAMPAIGN_NAME.META_CHALLAN_INF5,
  [UtmLeadProductType.YT_CHALLAN_INF1]: CAMPAIGN_NAME.YT_CHALLAN_INF1,
  [UtmLeadProductType.YT_CHALLAN_INF2]: CAMPAIGN_NAME.YT_CHALLAN_INF2,
  [UtmLeadProductType.YT_CHALLAN_INF3]: CAMPAIGN_NAME.YT_CHALLAN_INF3,
  [UtmLeadProductType.YT_CHALLAN_INF4]: CAMPAIGN_NAME.YT_CHALLAN_INF4,
  [UtmLeadProductType.YT_CHALLAN_INF5]: CAMPAIGN_NAME.YT_CHALLAN_INF5,
  [UtmLeadProductType.KA_DISC_CHLN_GOV]: CAMPAIGN_NAME.KA_DISC_CHLN_GOV,
}

export const DEFAULT_CAMPAIGN_NAME = {
  [CHALLAN_WIDGET_LANDING]: CAMPAIGN_NAME.SEO_CHALLAN,
  [FASTAG_WIDGET_LANDING]: CAMPAIGN_NAME.SEO_FASTag,
  [HSRP_WIDGET_LANDING]: CAMPAIGN_NAME.SEO_HSRP,
  [RTO_WIDGET]: CAMPAIGN_NAME.SEO_RTO,
  [ABHA_SEO_WIDGET]: CAMPAIGN_NAME.SEO_ABHA,
}

export const sourceNameConfig = {
  [UtmLeadProductType.PMAX_CHALLAN]: CAMPAIGN_SOURCE.PMAX_CHALLAN,
  [UtmLeadProductType.SEM_CHALLAN]: CAMPAIGN_SOURCE.SEM_CHALLAN,
  [UtmLeadProductType.SEM_CHALLAN_1]: CAMPAIGN_SOURCE.SEM_CHALLAN_1,
  [UtmLeadProductType.SEM_CHALLAN_2]: CAMPAIGN_SOURCE.SEM_CHALLAN_2,
  [UtmLeadProductType.SEM_CHALLAN_3]: CAMPAIGN_SOURCE.SEM_CHALLAN_3,
  [UtmLeadProductType.SEM_CHALLAN_4]: CAMPAIGN_SOURCE.SEM_CHALLAN_4,
  [UtmLeadProductType.SEM_CHALLAN_5]: CAMPAIGN_SOURCE.SEM_CHALLAN_5,
  [UtmLeadProductType.SEM_CHALLAN_6]: CAMPAIGN_SOURCE.SEM_CHALLAN_6,
  [UtmLeadProductType.SEM_CHALLAN_7]: CAMPAIGN_SOURCE.SEM_CHALLAN_7,
  [UtmLeadProductType.SEM_CHALLAN_8]: CAMPAIGN_SOURCE.SEM_CHALLAN_8,
  [UtmLeadProductType.SEM_CHALLAN_9]: CAMPAIGN_SOURCE.SEM_CHALLAN_9,
  [UtmLeadProductType.SEM_CHALLAN_10]: CAMPAIGN_SOURCE.SEM_CHALLAN_10,
  [UtmLeadProductType.META_CHALLAN]: CAMPAIGN_SOURCE.META_CHALLAN,
  [UtmLeadProductType.SEO_CHALLAN]: CAMPAIGN_SOURCE.SEO_CHALLAN,
  [UtmLeadProductType.INSTAGRAM_CHALLAN]: CAMPAIGN_SOURCE.INSTAGRAM_CHALLAN,
  [UtmLeadProductType.ZEPTO_CHALLAN]: CAMPAIGN_SOURCE.ZEPTO_CHALLAN,
  [UtmLeadProductType.ZOMATO_CHALLAN]: CAMPAIGN_SOURCE.ZOMATO_CHALLAN,
  [UtmLeadProductType.SEO_FASTAG]: CAMPAIGN_SOURCE.SEO_FASTag,
  [UtmLeadProductType.SEM_FASTAG]: CAMPAIGN_SOURCE.SEM_FASTAG,
  [UtmLeadProductType.PMAX_FASTAG]: CAMPAIGN_SOURCE.PMAX_FASTAG,
  [UtmLeadProductType.BRANDFORMANCE_FASTAG]: CAMPAIGN_SOURCE.BRANDFORMANCE_FASTAG,
  [UtmLeadProductType.META_FASTAG]: CAMPAIGN_SOURCE.META_FASTAG,
  [UtmLeadProductType.WHATSAPP_WINBACK_CHALLAN]: CAMPAIGN_SOURCE.WHATSAPP_WINBACK_CHALLAN,
  [UtmLeadProductType.BRANDFORMANCE_CHALLAN]: CAMPAIGN_SOURCE.BRANDFORMANCE_CHALLAN,
  [UtmLeadProductType.SEO_HSRP]: CAMPAIGN_SOURCE.SEO_HSRP,
  [UtmLeadProductType.SEM_HSRP]: CAMPAIGN_SOURCE.SEM_HSRP,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_U1]: CAMPAIGN_SOURCE.CX_WA_WNBCK_CHLN_U1,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_U2]: CAMPAIGN_SOURCE.CX_WA_WNBCK_CHLN_U2,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_U3]: CAMPAIGN_SOURCE.CX_WA_WNBCK_CHLN_U3,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_U4]: CAMPAIGN_SOURCE.CX_WA_WNBCK_CHLN_U4,
  [UtmLeadProductType.CX_WA_WNBCK_CHLN_P1]: CAMPAIGN_SOURCE.CX_WA_WNBCK_CHLN_P1,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U1]: CAMPAIGN_SOURCE.NCX_WA_WNBCK_CHLN_U1,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U2]: CAMPAIGN_SOURCE.NCX_WA_WNBCK_CHLN_U2,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U3]: CAMPAIGN_SOURCE.NCX_WA_WNBCK_CHLN_U3,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U4]: CAMPAIGN_SOURCE.NCX_WA_WNBCK_CHLN_U4,
  [UtmLeadProductType.NCX_WA_WNBCK_CHLN_P1]: CAMPAIGN_SOURCE.NCX_WA_WNBCK_CHLN_P1,
  [UtmLeadProductType.META_CHALLAN_INF1]: CAMPAIGN_SOURCE.META_CHALLAN_INF1,
  [UtmLeadProductType.META_CHALLAN_INF2]: CAMPAIGN_SOURCE.META_CHALLAN_INF2,
  [UtmLeadProductType.META_CHALLAN_INF3]: CAMPAIGN_SOURCE.META_CHALLAN_INF3,
  [UtmLeadProductType.META_CHALLAN_INF4]: CAMPAIGN_SOURCE.META_CHALLAN_INF4,
  [UtmLeadProductType.META_CHALLAN_INF5]: CAMPAIGN_SOURCE.META_CHALLAN_INF5,
  [UtmLeadProductType.YT_CHALLAN_INF1]: CAMPAIGN_SOURCE.YT_CHALLAN_INF1,
  [UtmLeadProductType.YT_CHALLAN_INF2]: CAMPAIGN_SOURCE.YT_CHALLAN_INF2,
  [UtmLeadProductType.YT_CHALLAN_INF3]: CAMPAIGN_SOURCE.YT_CHALLAN_INF3,
  [UtmLeadProductType.YT_CHALLAN_INF4]: CAMPAIGN_SOURCE.YT_CHALLAN_INF4,
  [UtmLeadProductType.YT_CHALLAN_INF5]: CAMPAIGN_SOURCE.YT_CHALLAN_INF5,
  [UtmLeadProductType.KA_DISC_CHLN_GOV]: CAMPAIGN_SOURCE.KA_DISC_CHLN_GOV,
}

export const DEFAULT_SOURCE_NAME = {
  [CHALLAN_WIDGET_LANDING]: CAMPAIGN_SOURCE.SEO_CHALLAN,
  [FASTAG_WIDGET_LANDING]: CAMPAIGN_SOURCE.SEO_FASTag,
  [HSRP_WIDGET_LANDING]: CAMPAIGN_SOURCE.SEO_HSRP,
  [RTO_WIDGET]: CAMPAIGN_SOURCE.SEO_RTO,
  [ABHA_SEO_WIDGET]: CAMPAIGN_SOURCE.SEO_ABHA,
}

export const customIosStoreIdConfig = {
  [CHALLAN_WIDGET_LANDING]: '76dc0660-df4f-4af0-9c6b-0a55b3feb0e9',
  [FASTAG_WIDGET_LANDING]: '1c551935-72df-407d-922f-cd095ba3b12c',
  [HSRP_WIDGET_LANDING]: '41008fae-401c-418f-b11f-7b7e96dc122a',
  [RTO_WIDGET]: '41008fae-401c-418f-b11f-7b7e96dc122a',
  [ABHA_SEO_WIDGET]: 'ead9e24c-1c3b-480d-86e8-263a830a1fe9',
  Default: '76dc0660-df4f-4af0-9c6b-0a55b3feb0e9',
}

export const customAndroidStoreIdConfig = {
  PMAX_CHALLAN: 'pmax-challan-may25',
  SEO_CHALLAN: 'seo-challan-jan25',
  SEM_CHALLAN: 'sem-challan-jan25',
  META_CHALLAN: 'meta-challan-jan25',
  INSTAGRAM_CHALLAN: 'sem-challan-jan25',
  ZEPTO_CHALLAN: 'sem-challan-jan25',
  ZOMATO_CHALLAN: 'sem-challan-jan25',
  SEO_FASTag: 'vas-fastag-may-25',
  SEM_FASTAG: 'vas-fastag-may-25',
  PMAX_FASTAG: 'vas-fastag-may-25',
  BRANDFORMANCE_FASTAG: 'vas-fastag-may-25',
  META_FASTAG: 'vas-fastag-may-25',
  WHATSAPP_WINBACK_CHALLAN: 'winback-challan-may25',
  BRANDFORMANCE_CHALLAN: 'brandformance-challan-may25',
  SEO_HSRP: 'wrapper_app_download_assets',
  SEM_HSRP: 'wrapper_app_download_assets',
  CX_WA_WNBCK_CHLN_U1: 'winback-challan-july25',
  CX_WA_WNBCK_CHLN_U2: 'winback-challan-july25',
  CX_WA_WNBCK_CHLN_U3: 'winback-challan-july25',
  CX_WA_WNBCK_CHLN_U4: 'winback-challan-july25',
  CX_WA_WNBCK_CHLN_P1: 'winback-challan-july25',
  NCX_WA_WNBCK_CHLN_U1: 'winback-challan-july25',
  NCX_WA_WNBCK_CHLN_U2: 'winback-challan-july25',
  NCX_WA_WNBCK_CHLN_U3: 'winback-challan-july25',
  NCX_WA_WNBCK_CHLN_U4: 'winback-challan-july25',
  NCX_WA_WNBCK_CHLN_P1: 'winback-challan-july25',
  META_CHALLAN_INF1: 'meta-challan-jan25',
  META_CHALLAN_INF2: 'meta-challan-jan25',
  META_CHALLAN_INF3: 'meta-challan-jan25',
  META_CHALLAN_INF4: 'meta-challan-jan25',
  META_CHALLAN_INF5: 'meta-challan-jan25',
  YT_CHALLAN_INF1: 'meta-challan-jan25',
  YT_CHALLAN_INF2: 'meta-challan-jan25',
  YT_CHALLAN_INF3: 'meta-challan-jan25',
  YT_CHALLAN_INF4: 'meta-challan-jan25',
  YT_CHALLAN_INF5: 'meta-challan-jan25',
  KA_DISC_CHLN_GOV: 'winback-challan-july25',
  SEO_RTO: 'wrapper_app_download_assets',
  SEO_ABHA: 'wrapper_app_download_abha',
}

export const DEFAULT_CUSTOM_ANDROID_STORE_ID = {
  [CHALLAN_WIDGET_LANDING]: customAndroidStoreIdConfig.SEO_CHALLAN,
  [FASTAG_WIDGET_LANDING]: customAndroidStoreIdConfig.SEO_FASTag,
  [HSRP_WIDGET_LANDING]: customAndroidStoreIdConfig.SEO_HSRP,
  [RTO_WIDGET]: customAndroidStoreIdConfig.SEO_RTO,
  [ABHA_SEO_WIDGET]: customAndroidStoreIdConfig.SEO_ABHA,
  Default: customAndroidStoreIdConfig.SEO_CHALLAN,
}
export const SHOW_PASS_BANNER = {
  'travel-seo-widget': true,
  'travel-sem-widget': true,
}
